import React, { useEffect, useMemo, useState } from 'react';

import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import DashboardLayout from 'components/dashboardLayout/dashboardLayout';
import * as Styled from './ViewEditor.styles';
import sortBy from 'lodash/sortBy';
import { TextField as TextFieldMUI } from "@mui/material";
import { Datagrid, Button, TextField, Form} from "./controls";
import differenceWith from 'lodash/differenceWith';
import { Responsive, WidthProvider } from 'react-grid-layout';
import classnames from 'classnames';
import { DeleteOutline } from '@mui/icons-material';

const ResponsiveGridLayout = WidthProvider(Responsive);

/*     render({
        "type": "datagrid",
        "children": [],
        "properties": {     
            "columns": [
                {field: 'id', name: 'ID', width: 70},
                {field: 'No', name: 'Numer', width: 170},
                {field: 'contractor', name: 'klient', width: 170, main:true},
                {field: 'valueNet', name: 'Wartość netto', width: 170}
                  ]
        },
        data:[{
            id: 1,
            No: '2021/01/01',
            contractor: 'Kowalski',
            valueNet: '100,00'
            },
            {   id: 2,  
                No: '2021/01/02',
                contractor: 'Nowak',
                valueNet: '200,00'
            },
	        {   id: 3,  
                No: '2021/01/02',
                contractor: 'Nowak',
                valueNet: '200,00'
            },
            {   id:4,  
                No: '2021/01/02',
                contractor: 'Nowak',
                valueNet: '200,00'
            }]
    })

      render({
        id: 'sampleButton',
        label:'Label',
        type: 'button',
        children: [],
        position: { w: 4, h: 2,x:0,y:0 },
        properties: {     
           label: 'Przycisk'
        }});

    render({
        "type": "textfield",
        "children": [],
        "properties": {     
           value: 'wartosć'
        }});

render({
    "type": "form",
    "properties": {
        "label": "Formularz",
        "fields": [{
            "name": "firstname",         
            "properties": {     
                "label": "Imię",    
            }},
            {
            "name": "surname",            
            "properties": {     
                 "label": "Nazwisko",    
            }           
        }]
    },   
})



*/    


export const ViewEditor = () => {
    const items =[];
    const [gridItems, setGridItems] = useState([]);
    const [editLayoutData, setEditLayoutData] = useState(null);
    const [currentLayoutWidth, setCurrentLayoutWidth] = useState(null);
    const [savedData, setSavedData] = useState([]);    
   
    const [compilationError, setCompilationError] = useState('');
    const [renderedUI, setRenderedUI] = useState([]);
    const [code, setCode] = useState('');

    const compile=()=>{        
        try{           
            eval(code);            
            setGridItems(items);                       
            setCompilationError('');
        }catch(e){
            setCompilationError(e.message);
        }
    }
    
    const handleChange=(e)=>{
        setCode(e.target.value);
    }

   
    const render=(schema)=>{          
         
        if(schema.type==='textfield'){
            items.push(
                {
                    id: schema.id,
                    originalSchema:schema,
                    label: schema.label,
                    position: schema.position,/*{ w: 4, h: 2 },*/
                    content:  (<TextField properties={schema.properties}>
                        {schema.children?.map(child=>render(child))}
                    </TextField>)
                  }
           );
        }
        else if(schema.type==='button'){           
            items.push(
                {
                    id: schema.id,
                    originalSchema:schema,
                    label: schema.label,
                    position: schema.position,/*{ w: 4, h: 2 },*/
                    content:  (<Button properties={schema.properties}>
                        {schema.children?.map(child=>render(child))}
                    </Button>)
                  }
           );
        
        }
        else if(schema.type==='form'){
            items.push(
                {
                    id: schema.id,
                    originalSchema:schema,
                    label: schema.label,
                    position: schema.position,/*{ w: 4, h: 2 },*/
                    content:  (<Form properties={schema.properties}>
                        {schema.children?.map(child=>render(child))}
                    </Form>)
                  }
           );
      
        }
        else if(schema.type==='datagrid'){
            items.push(
                {
                    id: schema.id,
                    originalSchema:schema,
                    label: schema.label,
                    position: schema.position,/*{ w: 4, h: 2 },*/
                    content:  (<Datagrid data ={ schema.data} properties={schema.properties}>
                        {schema.children?.map(child=>render(child))}
                    </Datagrid>)
                  }
           );
        }
    }

    const onLayoutChange = (layout) =>   {     
   
    setGridItems((old) =>
      (old || []).map((widget) => {
        const layoutItem = layout.find((layoutItem) => layoutItem.i === widget.id);

        return {
          ...widget,
          position: {
            x: layoutItem.x,
            y: layoutItem.y,
            w: layoutItem.w,
            h: layoutItem.h,
          },
        };
      }),
    );
      
    var data = gridItems.map((item)=>{
        item.originalSchema.position=item.position;
        return  'render(' + JSON.stringify(item.originalSchema, null, '\t') +');';
      }).join('\n');
    setCode(data);

    };
    const onKeyDown=(e) => {
        const { value } = e.target;
    
        if (e.key === 'Tab') {
          e.preventDefault();
    
          const cursorPosition = e.target.selectionStart;
          const cursorEndPosition = e.target.selectionEnd;
          const tab = '\t';
    
          e.target.value =
            value.substring(0, cursorPosition) +
            tab +
            value.substring(cursorEndPosition);
    
          // if you modify the value programmatically, the cursor is moved
          // to the end of the value, we need to reset it to the correct
          // position again
          e.target.selectionStart = cursorPosition + 1;
          e.target.selectionEnd = cursorPosition + 1;
        }
      };

     const layouts = useMemo(
        () => ({
          desktop: gridItems.map((gridItem) => ({
            i: gridItem.id,
            ...gridItem.position,
            static: false,
          })),
          mobile: sortBy(gridItems, [(gridItem) => gridItem.position.y, (gridItem) => gridItem.position.x]).reduce(
            (acc, gridItem, index) => {
              const lastItem = acc[index - 1];
    
              return [
                ...acc,
                {
                  i: gridItem.id,
                  ...gridItem.position,
                  static: false,
                  x: 0,
                  y: lastItem ? lastItem.h + lastItem.y : 0,
                  w: 1,
                },
              ];
            },
            [],
          ),
        }),
        [gridItems, editLayoutData],
      );

    return (
        <DashboardLayout>
        <Grid container>
        <Grid item  xs={6}>
            <Styled.Stack>
                <Styled.TextField value={code} onKeyDown={(e)=>onKeyDown(e)} multiline rows={30} onChange={(e) => handleChange(e)} />
                <Styled.Label>Output:</Styled.Label>
                <Styled.TextField multiline rows={2} value={compilationError}></Styled.TextField>
                <Button onClick={() =>compile()} variant="contained" color="primary" properties={{label:'Wykonaj'}}/>
            </Styled.Stack>
        </Grid>
        <Grid item xs={6}>
       
        <Styled.LayoutWrapper className={classnames({ isEditing: !!editLayoutData })}>
        <Styled.Stack>
        <ResponsiveGridLayout 
          layouts={{ desktop: layouts.desktop, mobile: layouts.mobile }}
          breakpoints={{ desktop: 1000, mobile: 0 }}
          cols={{ desktop: 12, mobile: 1 }}
          rowHeight={60}
          onLayoutChange={onLayoutChange}
          onWidthChange={(width) => {
            setCurrentLayoutWidth(width);
            setEditLayoutData(null);
          }}
        >
          {gridItems?.map((gridItem) => (          
            <div key={gridItem.id} className={classnames('item')}>
              {gridItem.content}
              {editLayoutData  && (
                <Button
                  onClick={() =>
                    setEditLayoutData((old) => (old || []).filter((layoutItem) => layoutItem.id !== gridItem.id))
                  }
                  className="deleteButton"
                  variant="text"
                  color="error"
                >
                  <DeleteOutline />
                </Button>
              )}
            </div>
          ))}
        </ResponsiveGridLayout>
        </Styled.Stack>
        </Styled.LayoutWrapper>
    
        </Grid>
        </Grid>     
        </DashboardLayout>
    )
}
